// Module
var code = "<div class=\"dms-parent-child\">\n    <div class=\"dms-content-header\"></div>\n    <div class=\"dms-content-wrapper\"></div>\n</div>\n";
// Exports
export default code;